import { useState, useEffect } from "react";
import ReactModal from "react-modal";

const MilestonesPopup = ({ open, setOpen, achievments = {} }) => {
  return (
    <ReactModal
      isOpen={open}
      onRequestClose={() => setOpen(false)}
      className="relative w-[100%] max-w-[90%] md:max-w-[560px] h-screen max-h-[75%] md:max-h-[500px] bg-white font-[Lato] outline-none overflow-y-auto rounded-3xl"
      overlayClassName="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-black/50 z-50"
    >
      <div className="relative bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-t-3xl p-7 text-white text-center text-[20px] font-[700] font-[Lato] relative">
        <p>{achievments?.title}</p>

        <div className="absolute right-2 top-[35%] ">
          <button
            onClick={() => setOpen(false)}
            className="border border-white rounded-full"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="24" height="24" rx="12" />
              <path
                d="M16 8L8 16"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 8L16 16"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="p-5 md:pt-12 md:pb-6 md:px-20 text-center">
        <div className="flex justify-center w-full">
          {achievments?.RankImage && (
            <achievments.RankImage
            // className="mx-auto w-20 h-20 mb-4"
            />
          )}
        </div>
        <h2 className="text-[18px] font-[700] font-[Lato] text-center">
          {achievments?.subheading}
        </h2>
        <div className="px-6 pt-5 pb-12 rounded-[11px] border border-[#E6E6E6] shadow-md mt-4">
          <p className="text-[#6C6C6C] font-[500] text-[16px] font-[Lato]">
            {achievments?.description}
          </p>
        </div>
      </div>
    </ReactModal>
  );
};

export default MilestonesPopup;
